import { style } from 'typestyle';

export const flexH = style({
  display: 'flex',
  flexWrap: 'nowrap',
  flexDirection: 'row',
  alignContent: 'stretch',
  alignItems: 'stretch',
  justifyContent: 'flex-start',
});

export const flexV = style({
  display: 'flex',
  flexWrap: 'nowrap',
  flexDirection: 'column',
  alignContent: 'stretch',
  alignItems: 'stretch',
  justifyContent: 'flex-start',
});

export const flexItemCenter = style({
  alignItems: 'center',
});

export const flexNone = style({
  flex: '0 0 auto',
});

export const flexAuto = style({
  flex: '1 1 auto',
});

export const absolute = style({
  position: 'absolute',
});

export const relative = style({
  position: 'relative',
});

export const fulfill = style({
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
});

export const center = style({
  top: '50%',
  left: '50%',
  transform: 'translate(-50%,-50%)',
});

export const overflowAuto = style({
  overflow: 'auto',
});
